import { Spinner } from "components/spinner";
import gql from "graphql-tag";
import { useGetEmptySearchesQuery } from "lib/graphql-generated";
import { GetServerSideProps } from "next";

gql`
  query GetEmptySearches($date: timestamptz) {
    empty_searches(
      order_by: { created_at: desc }
      limit: 50
      where: { created_at: { _gte: $date } }
    ) {
      id
      string
    }
  }
`;

interface Props {
  sevenDaysAgo: string;
}

export const EmptySearchResults = ({ sevenDaysAgo }: Props) => {
  const { data, loading } = useGetEmptySearchesQuery({
    variables: {
      date: sevenDaysAgo,
    },
    skip: !sevenDaysAgo,
  });

  return (
    <article className=' bg-white  overflow-hidden shadow rounded-lg space-y-5'>
      <header className='px-5 pt-5 flex flex-col justify-start'>
        <h2 className='header text-gray-900'>Empty Searches</h2>
        <p className='text-sm text-gray-500'>
          A list of recent searches made by readers in the last 7 days which
          resulted in no results.
        </p>
      </header>
      <section className=' text-sm text-gray-900'>
        <ul className='border-t overflow-y-scroll max-h-32'>
          {loading ? (
            <div className='flex justify-center pt-8'>
              <Spinner />
            </div>
          ) : (
            <>
              {data?.empty_searches.map((r) => (
                <li key={r.id} className='px-5 py-1.5 even:bg-gray-100'>
                  {r.string}
                </li>
              ))}
            </>
          )}
        </ul>
      </section>
    </article>
  );
};
